// extracted by mini-css-extract-plugin
module.exports = {"banner":"_2uuFd","loading":"_3WIJ8"};